import { type Actions, ActionType } from './combined-list.actions';
import { initialState, type State } from './combined-list.state';

export function combinedListReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.SET_LEGACY_COMBINED_LISTS: {
            return {
                ...state,
                combinedList: action.payload.combinedList,
                isPending: false,
                isLoaded: true
            };
        }

        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
}
